exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon-information-text{font-size:14px;line-height:14px;height:14px;width:14px;vertical-align:-1px}", ""]);

